<template>
    <div class="side-navigation grid grid__base" :class="rootClasses">
        <transition name="trs-side-panel">
            <nav class="side-navigation--panel" v-if="isOpen" @click.stop>
                <div class="grid--container">
                    <ul class="side-navigation--list side-navigation--list__root u-reset">
                        <li class="side-navigation--item" v-for="(item, index) in items" :key="index">
                            <template v-if="item.path && !item.children.length">
                                <a :href="item.path"
                                        class="side-navigation--link side-navigation--link__main u-reset">
                                    {{ item.label }}
                                </a>
                            </template>
                            <ui-accordion :is-open="checkIfAccordionIsOpen(item)" v-else>
                                <div class="side-navigation--link side-navigation--link__main"
                                        slot-scope="props"
                                        slot="head">
                                    <conditional-link v-bind="item"
                                            class="side-navigation--accordion-head u-reset">
                                        {{ item.label }}
                                        <ui-icon class="collapsible--icon"
                                                :symbol="getIcon(props)"
                                                size="medium"/>
                                    </conditional-link>
                                </div>
                                <ul class="side-navigation--list side-navigation--list__child u-reset" slot="body">
                                    <li class="side-navigation--item"
                                            :class="getItemClasses(child)"
                                            v-for="(child, j) in item.children"
                                            :key="j">
                                        <a :href="child.path"
                                                :class="bemAdd(child.is_active ? 'active' : 'base', 'link')"
                                                class="side-navigation--link side-navigation--link__child u-reset">
                                            {{ child.label }}
                                        </a>
                                    </li>
                                </ul>
                            </ui-accordion>
                        </li>
                    </ul>
                </div>
            </nav>
        </transition>
    </div>
</template>

<script>
    import { add as addEvent, remove as removeEvent } from 'bianco.events';
    import { mapState, mapActions } from 'vuex';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import UiAccordion from '@dreipol/vue-ui/src/components/accordion/accordion';
    import ConditionalLink from '../../components/conditional-link/conditional-link';
    import { mq } from '../../../util/dom/mq';


    export default {
        components: { ConditionalLink, UiAccordion, UiIcon },
        mixins: [bemMixin('side-navigation')],
        props: {
            items: {
                type: Array,
                required: true,
            },
        },
        computed: {
            ...mapState('side-navigation', ['isOpen']),
            ...mapState('viewport', ['mq']),
            isHamburgerVisible() {
                return this.mq && mq('<=md');
            },
            rootClasses() {
                return [
                    this.bemIf(this.isOpen, 'is-open'),
                ];
            },
        },
        methods: {
            ...mapActions('side-navigation', ['toggle']),
            ...mapActions('vue-ui/scroll', ['disableScroll']),
            getItemClasses(item) {
                return item.facets.map(facet => this.bemAdd(facet, 'item'));
            },
            onClickOutside() {
                this.closeSidebar();
            },
            onKeyPress(event) {
                if (event.key === 'Escape') {
                    this.closeSidebar();
                }
            },
            closeSidebar() {
                this.toggle({ isOpen: false });
            },
            getIcon({ isOpen }) {
                return isOpen ? 'chevron_up' : 'chevron_down';
            },
            checkIfAccordionIsOpen(item) {
                return item.is_active || item.children.some(child => child.is_active);
            },
        },
        watch: {
            isOpen(value) {
                clearTimeout(this.scrollLockTimer);

                // wait that the animation ends to lock/unlock the scrollbar
                this.scrollLockTimer = setTimeout(() => {
                    this.disableScroll({
                        isLocked: value,
                    });
                }, 300); // 300ms is the duration of the menu slide animation
            },
            isHamburgerVisible(isHamburgerVisible, wasAmburgerVisible) {
                if (wasAmburgerVisible && !isHamburgerVisible) {
                    this.closeSidebar();
                }
            },
        },
        mounted() {
            addEvent(window, 'click', this.onClickOutside);
            addEvent(document, 'keydown', this.onKeyPress);
        },
        beforeDestroy() {
            removeEvent(window, 'click', this.onClickOutside);
            removeEvent(document, 'keydown', this.onKeyPress);
        },
    };
</script>
